
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import ScheduleList from './List';
import ScheduleAdd from './Add';
import ScheduleDetail from './Detail';


export default class ScheduleRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/schedule/add" exact component={ScheduleAdd} />
        <Route path="/schedule/add/:id" exact component={ScheduleAdd} />
        <Route path="/schedule/:id" exact component={ScheduleDetail} />
        <Route path="/schedule" exact component={ScheduleList} />
      </Switch>
    );
  }
}
